var frdcouponcopy2clipboard = document.querySelectorAll(".frdcouponspan"); 

for (const copied of frdcouponcopy2clipboard) { 
  copied.onclick = function() { 
    document.execCommand("copy"); 
  };  
  copied.addEventListener("copy", function(event) { 
    event.preventDefault(); 
    if (event.clipboardData) { 
      event.clipboardData.setData("text/plain", copied.textContent);
      //console.log(event.clipboardData.getData("text"))
    };
  });
};
